import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalService } from '../services/global/global.service';
import { UtilsService } from '../services/utils/utils.service';
import { LoginPage } from '../pages/auth/login/login.page';

@Injectable({
  providedIn: 'root'
})
export class MywalletGuard implements CanActivate {
  constructor(
    private global:GlobalService,
    private router:Router,
    private uti:UtilsService
  ){

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return new Promise(resolve=>{
      this.global.uid_value.subscribe(uid=>{
        console.log(uid);
        
        if(uid && uid!=""){
          resolve(true);
        }else{
          this.uti.edcModal(LoginPage, "");
          resolve(false);
        }
      });
    });
      
  }
  
}